var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.background},[_c('GiantTitle',{class:_vm.$style.bigTitle,style:({
      transform: ("translateY(" + (((_vm.delta2))) + "%)"),
      opacity: _vm.opacity,
    }),attrs:{"data-title":"","title":_vm.getCurrentData.title},nativeOn:{"click":function($event){_vm.scrollTo($event)}}}),_vm._v(" "),(_vm.enableSlider)?_c('div',{class:_vm.$style.heroDiscover,style:({
      transform: ("translate3d(-50%, " + (1920 * (_vm.delta)) + "%, 0)"),
      opacity: _vm.delta > 0 ? 0 : 1
    }),attrs:{"data-scroll":""}},[_c('p',[_vm._v("scroll to")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_vm._v("discover")])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e80e47a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = null
// module chunks = 